
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const ECHECK_BASE = "/echeck";
const buildUrl = (endpoint) => ECHECK_BASE + endpoint;


const echeckApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        StartFindOrders: builder.query({
            query: (id, workspaceId) => ({
                url: buildUrl(`/startfindorders/${id}/${workspaceId}`),
                method: 'GET',
            }),
            keepUnusedDataFor:0,
            //providesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }]
        }),
        StartFindOrdersMutation: builder.mutation({
            query: (id, workspaceId) => ({
                url: buildUrl(`/startfindorders/${id}/${workspaceId}`),
                method: 'GET',
            }),
        }),
        findPickingJobs: builder.query({
            query: (body) => ({
                
              url: buildUrl(`/findpickingjobs`+(body.completed ? "?size=25&page="+body.page : "")),
              method: 'POST', 
              body
            }),

            providesTags: (result, error, arg) => {
                return [{ type: `AllPickingJobs` }];
            },
        }),
        pauseOrder: builder.mutation({
            query: (body) => ({
              url: buildUrl(`/pauseorder/${body.id}`),
              method: 'PUT',
              body,
            }),
        }),
        restartOrderEcheck: builder.mutation({
            query: (id) => ({
              url: buildUrl(`/restartorder/${id}`),
              method: 'POST',
            }),
        }),
        findProductInPickingJob: builder.mutation({
            query: (body) => ({
              url: buildUrl(`/findproductinpickingjob`),
              method: 'POST', 
              body,
            }),
        }),
        findProductByIdInPickingJob: builder.mutation({
            query: (body) => ({
              url: buildUrl(`/findproductbyidinpickingJob`),
              method: 'POST', 
              body,
            }),
        }),
        findLocationInPickingJob: builder.mutation({
            query: (body) => ({
              url: buildUrl(`/findlocationinpickingjob`),
              method: 'POST', 
              body,
            }),
        }),
        findOrderInPickingJob: builder.mutation({
            query: (id) => ({
              url: buildUrl(`/findorder/${id}`),
              method: 'GET', 
            }),
        }),
        findIndividualOrder: builder.mutation({
            query: (id) => ({
              url: buildUrl(`/findindividualorder/${id}`),
              method: 'GET', 
            }),
        }),
        findPickingJob: builder.mutation({
            query: (body) => ({
              url: buildUrl(`/pickingjob/${body.id}`),
              method: 'POST', 
              body
            }),
        }),
        pickingJob: builder.query({
            query: (id) => ({
              url: buildUrl(`/pickingjob/${id}`),
              method: 'GET', 
            }),
        }),
        finalizeOrder: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/finalizeorder?_=${Date.now()}`),
                method: 'POST',
                body: body
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'OrdersForProcessing' }],
        }),
        finalizeOrders: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/finalizemultiple`),
                method: 'POST',
                body: body
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'OrdersForProcessing' }],
        }),
        setJoker: builder.mutation({
            query: id => ({
                url: buildUrl(`/joker/${id}`),
                method: 'GET'
            }),
            //providesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }]
        }),
        getDeliveryOptions: builder.query({
            query: (body) => ({
                url: buildUrl(`/deliveryoptions`),
                method: 'POST',
                body: body
            }),
        }),
        addShipment: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/addshipment`),
                method: 'POST',
                body: body
            }),
        }),
        addonsFromOrders: builder.query({
            query: (body) => ({
                url: buildUrl(`/orders/addons`),
                method: 'POST',
                body: body
            }),
            keepUnusedDataFor: 0,
        }),
    })
});

export const {
    useStartFindOrdersMutationMutation,
    useStartFindOrdersQuery,
    useFindProductInPickingJobMutation,
    useFindProductByIdInPickingJobMutation,
    useFindLocationInPickingJobMutation,
    useFinalizeOrderMutation,
    useFinalizeOrdersMutation,
    useSetJokerMutation,
    useGetDeliveryOptionsQuery,
    useAddShipmentMutation,
    useFindPickingJobMutation,
    useFindPickingJobsQuery,
    useFindOrderInPickingJobMutation,
    usePauseOrderMutation,
    useRestartOrderEcheckMutation,
    useFindIndividualOrderMutation,
    useAddonsFromOrdersQuery,
  } = echeckApiSlice;
